export const addedSuccessfully = "Le nouveau service a été ajouté avec succès";
export const tryAddAgain = "Le service n'a pas été ajouté. Une erreur s'est produite, veuillez réessayer.";

export const updatedSuccessfully = "Le service a été mis à jour avec succès.";
export const tryUpdateAgain = "Une erreur s'est produite. Le service n'a pas été mis à jour.";

export const deletedSuccessfully = "Le service a été supprimé avec succès.";
export const tryDeleteAgain = "Une erreur s'est produite. Le service n'a pas été supprimé, veuillez réessayer.";